import { combineEpics } from 'redux-observable'
import notifyLocalPresenterWhenNewDialInParticipantEnters$ from './notifyLocalPresenterWhenNewDialInParticipantEnters'
import notifyLocalPresenterWhenMuted$ from './notifyLocalPresenterWhenMuted'
import notifyPresenterWhenDialledInParticipantAndAutoSpotlight$ from './notifyPresenterWhenDialedInParticipantAndAutoSpotlight'

export default combineEpics(
  notifyLocalPresenterWhenNewDialInParticipantEnters$,
  notifyLocalPresenterWhenMuted$,
  notifyPresenterWhenDialledInParticipantAndAutoSpotlight$
)
